import { getCurrencyWithPriceDisplay, getCurrencySign, CURRENCY_SIGN_RIGHT_OF_NUMBER_LOCALES } from "/services/pricing-service";
import { ADDON_CONFIG } from "constants/addons";
export const getAddonDisplayName = (addon)=>{
    var _ADDON_CONFIG_addon;
    return ((_ADDON_CONFIG_addon = ADDON_CONFIG[addon]) === null || _ADDON_CONFIG_addon === void 0 ? void 0 : _ADDON_CONFIG_addon.displayName) || addon;
};
const formatPriceAsString = (price, currency, localeId)=>{
    const currencySign = getCurrencySign(currency);
    const priceString = typeof price === "number" ? price.toLocaleString(localeId) : price;
    return CURRENCY_SIGN_RIGHT_OF_NUMBER_LOCALES.includes(localeId) ? `${priceString} ${currencySign}` : `${currencySign}${priceString}`;
};
export const renderTotalPriceWithAddon = ({ basePriceFormatted, basePriceRaw, addon, addonTotalPrice, currency, localeId, translateOrTranslateWithParam, includeTotalPrefix = false })=>{
    const basePriceString = typeof basePriceFormatted === "string" ? basePriceFormatted : formatPriceAsString(basePriceRaw, currency, localeId);
    if (!addon || !addonTotalPrice) {
        return includeTotalPrefix ? `Total ${basePriceString}` : basePriceString;
    }
    const addonPriceFormatted = getCurrencyWithPriceDisplay({
        price: addonTotalPrice.toLocaleString(),
        currency,
        localeId,
        hideCurrency: false
    });
    const addonPriceString = typeof addonPriceFormatted === "string" ? addonPriceFormatted : formatPriceAsString(addonTotalPrice, currency, localeId);
    const addonDisplayName = getAddonDisplayName(addon);
    const translationKey = "pricingPage.total.withAddon";
    const translation = translateOrTranslateWithParam(translationKey);
    let result;
    if (translation && translation !== translationKey) {
        result = translation.replace("%basePrice%", basePriceString).replace("%addonPrice%", addonPriceString).replace("%addonName%", addonDisplayName);
    } else {
        result = `${basePriceString} + ${addonPriceString} ${addonDisplayName} add-on`;
    }
    if (includeTotalPrefix && !result.startsWith("Total")) {
        result = `Total ${result}`;
    }
    return result;
};
